/**
 * Filter a list of unique values against a search query.
 *
 * @param {Array} options   - List of unique values from data.unique
 * @param {string} query    - User-typed search string
 * @param {string} mode     - "contains" | "startsWith" | "exact"
 * @param {boolean} caseSensitive
 * @returns {Array}         - Matching values
 */
export const filterSuggestions = (options, query, mode, caseSensitive) => {
  if (!query || !Array.isArray(options)) return []

  const normalizedQuery = caseSensitive ? query : query.toLowerCase()

  return options.filter(option => {
    const str = String(option)
    const normalized = caseSensitive ? str : str.toLowerCase()

    switch (mode) {
      case "startsWith":
        return normalized.startsWith(normalizedQuery)
      case "exact":
        return normalized === normalizedQuery
      case "contains":
      default:
        return normalized.includes(normalizedQuery)
    }
  })
}
